import {
    ChangeDetectionStrategy,
    Component,
    inject,
    ViewChild,
    ElementRef
} from "@angular/core";
import {
    MAT_BOTTOM_SHEET_DATA,
    MatBottomSheetRef
} from "@angular/material/bottom-sheet";
import { SharedDsnModule } from "@app/shared/modules/shared-dsn.module";
import { SharedMaterialModule } from "@app/shared/modules/shared-material.module";
import {
    CompanyEntity,
    ReportEntity,
    VisualizationEntity
} from "@arch/domain/entity";
import { VisualizationOptionsType } from "@arch/_shared/types/options-visualization";
import { CommentsPostComponent } from "../../../../../shared/components/comments-post/comments-post.component";
@Component({
    selector: "app-visualization-posts-bottom-sheet",
    imports: [SharedDsnModule, SharedMaterialModule, CommentsPostComponent],
    templateUrl: "./visualization-posts-bottom-sheet.component.html",
    styleUrl: "./visualization-posts-bottom-sheet.component.scss",
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class VisualizationPostsBottomSheetComponent {
    @ViewChild("postsContainer") postsContainer: ElementRef;
    readonly data = inject(MAT_BOTTOM_SHEET_DATA) as DialogPostsType;
    readonly bottomSheetRef = inject(
        MatBottomSheetRef<VisualizationPostsBottomSheetComponent>
    );

    public onCloseBottomSheet(): void {
        this.bottomSheetRef.dismiss();
    }
}

type DialogPostsType = {
    company: CompanyEntity;
    report: ReportEntity;
    options: VisualizationOptionsType;
    visualization: VisualizationEntity;
};
